module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAADMzAP///yH5BAAHAP8ALAAAAAAMAAwAAAIUhI+pGx38QFNzHWdvzBXV7mHZaBUAOw=="